var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkashaLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 74,
    viewBox: "0 0 205 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_714_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7162 4.78992H40.5639L24.669 31.8337H37.6196L8.67127 66.1147L17.0511 43.8321H5.05273L27.7162 4.78992Z",
    fill: "#37393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7084 4.88538H108.556L92.6612 31.9292H105.612L76.6635 66.2101L85.0432 43.9275H73.0449L95.7084 4.88538Z",
    fill: "#37393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.554 4.88538H183.402L167.507 31.9292H180.457L151.509 66.2101L159.889 43.9275H147.891L170.554 4.88538Z",
    fill: "#37393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5648 4.79016L53.1421 41.6421V14.2631H50.0949V5.26628H62.0932V22.3915L79.6488 4.88539L82.6617 13.0747C82.6617 13.0747 83.0426 14.027 82.6617 14.3869C82.258 14.7678 71.0443 25.073 71.0443 25.073L70.6634 25.4539L76.7578 34.5955L71.2348 44.118L62.1884 26.8823V43.7371H40.5648L32.3164 18.8225L40.5648 4.79016Z",
    fill: "#37393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.407 18.354V4.88544H129.058C129.058 4.88544 117.608 5.17111 117.608 17.3599C117.608 29.5487 131.035 29.0725 132.558 29.0725C134.082 29.0725 135.224 30.7866 135.224 31.7388C135.224 32.6911 135.224 34.786 132.507 34.786H118.846L108.554 4.88544L100.49 18.6035L108.554 43.6419H135.133C138.376 43.6419 141.031 39.8329 141.031 39.8329L141.29 43.6419H145.983L149.982 35.7383V27.2633H155.315L160.267 18.354H150.405H150.407ZM141.224 23.8352C139.51 21.5498 136.462 20.0262 134.341 20.0262H129.225C127.702 20.0262 126.654 18.5064 126.654 17.0742C126.654 15.3602 127.511 14.1222 129.797 14.1222H141.224V23.8352Z",
    fill: "#37393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.402 4.88544L196.55 44.118H183.402L175.119 18.9787L183.402 4.88544Z",
    fill: "#37393D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_714_1161",
    x: 0.955868,
    y: 0.519455,
    width: 203.511,
    height: 73.433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.90956,
    dy: 1.73596
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.00321
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_1161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_1161",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkashaLogoWhite);
export default __webpack_public_path__ + "static/media/Akasha Logo_White.9f744b0c6d52d05841614b2f8d692273.svg";
export { ForwardRef as ReactComponent };